import XRsign from './signin.vue';

export default XRsign


// WEBPACK FOOTER //
// ./src/components/signin/index.js